import {
	VOIP_NUMBER_POOL_CLEAR_STATE,
	VOIP_NUMBER_POOL_SET_AVAILABLE_NUMBERS,
	VOIP_NUMBER_POOL_SET_PREFIXES,
	VOIP_NUMBER_POOL_SET_PROVINCE
} from "./constants";
import { voipNumberPoolInitialState, VoipNumberPoolState } from "./module";

const clear = (state: VoipNumberPoolState) => {
	Object.assign(state, voipNumberPoolInitialState());
};

const setProvince = (state: VoipNumberPoolState, province: string) => {
	state.province = province;
	state.availableNumbers = [];
	state.prefixes = [];
};

const setAvailableNumbers = (state: VoipNumberPoolState, availableNumbers: string[]) => {
	state.availableNumbers = availableNumbers;
};

const setPrefixes = (state: VoipNumberPoolState, prefixes: number[]) => {
	state.prefixes = prefixes.map(String);
};

export default {
	[VOIP_NUMBER_POOL_CLEAR_STATE]: clear,
	[VOIP_NUMBER_POOL_SET_PROVINCE]: setProvince,
	[VOIP_NUMBER_POOL_SET_AVAILABLE_NUMBERS]: setAvailableNumbers,
	[VOIP_NUMBER_POOL_SET_PREFIXES]: setPrefixes
};
